export default __webpack_public_path__ + "static/media/3024.0ae7773e.jpg";